import React from 'react';
import { Col, Container, ListGroup, Row } from 'react-bootstrap';
import { Arrow } from './Arrow';
import CustomButton from '../../CustomButton';

const TextSection = ({ heading, info, lists, buttonLink }) => {

  return (
    <Container>
      <Row>
        <Col>
          <h4 style={{ color: '#004D90' }}>{heading}</h4>
          <p
            style={{
              color: '#606060',
              fontSize: '16px',
              lineHeight: '22px',
              fontWeight: 400,
            }}>
            {info}
          </p>
          {lists && lists.length > 0 && (
            <ListGroup variant="flush">
              {lists.map((link, index) => (
                <ListGroup.Item key={index} className="p-1 border-0 mt-2">
                  <Row className="align-items-center">
                    <Col
                      xs="auto"
                      className="d-flex flex-column align-items-center pe-0">
                      <Arrow />
                    </Col>
                    <Col>
                      <p
                        className="fw-semibold text-dark mb-0"
                        style={{ color: '#373737' }}>
                        {link.heading ? `${link.heading}:` : ''}
                      </p>
                      <p className="text-muted medium mb-0">{link.info}</p>
                    </Col>
                  </Row>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <CustomButton link={buttonLink} title="Get Started" />
        </Col>
      </Row>
    </Container>
  );
};

export default TextSection;
